var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.102,
    height: 17.102,
    viewBox: "0 0 17.102 17.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.538,
    y1: -0.387,
    x2: 0.945,
    y2: 0.956,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tag-fill",
    d: "M2.178,1A1.178,1.178,0,0,0,1,2.178v5.4a1.178,1.178,0,0,0,.345.832l8.244,8.244a1.178,1.178,0,0,0,1.665,0l5.4-5.4a1.178,1.178,0,0,0,0-1.665L8.411,1.345A1.178,1.178,0,0,0,7.579,1ZM6.889,5.122A1.767,1.767,0,1,1,5.122,3.355,1.767,1.767,0,0,1,6.889,5.122Z",
    transform: "translate(-0.5 -0.5)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagRequired);
export default __webpack_public_path__ + "static/media/tagRequired.da64d904cd0ed0f7ace7cbb3353098b3.svg";
export { ForwardRef as ReactComponent };